<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
-->

<gh-ext-page>
  <gh-ext-page-title title="{{'lbl_purchase_orders' | translate}}"></gh-ext-page-title>
  <gh-ext-page-content>
    <ng-container matSort="">
      <!-- Desktop version -->
      <mat-table *ghExtIfQuery="'gt-sm'" ghExtInfiniteTable="" [dataSource]="dataSource" [tracker]="tracker" [trackBy]="getOrderId">
        <ng-container matColumnDef="deliveryDate">
          <mat-header-cell fxFlex="15%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_delivery_date' | translate}}</mat-header-cell>
          <mat-cell fxFlex="15%" *matCellDef="let order">{{ order.deliveryDate | typeFormat:'ShortDate' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell fxFlex="15%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_status' | translate}}</mat-header-cell>
          <mat-cell fxFlex="15%" *matCellDef="let order">{{ order.status }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="officeName">
          <mat-header-cell fxFlex="15%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_office' | translate}}</mat-header-cell>
          <mat-cell fxFlex="15%" *matCellDef="let order">{{ order.officeName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="purchaseOrder">
          <mat-header-cell fxFlex="25%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_purchase_order_number' | translate}}</mat-header-cell>
          <mat-cell fxFlex="25%" *matCellDef="let order">{{ order.purchaseOrder }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="jobOrderId">
          <mat-header-cell *matHeaderCellDef="" class="cell-align-right">
            <span>{{'lbl_show_rejected' | translate}}</span>
            <mat-slide-toggle [checked]="showRejected" (change)="toggleRejected($event)" class="table-toggler"></mat-slide-toggle>
          </mat-header-cell>
          <mat-cell *matCellDef="let order" class="cell-align-right">
            <button *ngIf="isOrderPending(order)" type="button" class="small cell-button" mat-stroked-button="" (click)="reject(order)">{{'lbl_reject' | translate}}</button>

            <button *ngIf="isOrderPending(order)" type="button" class="small cell-button" color="primary" mat-flat-button="" (click)="accept(order)">{{'lbl_accept' | translate}}</button>

            <button *ngIf="order.fileUrl" type="button" class="small cell-button" mat-stroked-button="" (click)="view(order)">{{'lbl_view' | translate}}</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let order; columns: displayedColumns" [ghExtInfiniteRow]="order" [ngClass]="getRowClass(order)"></mat-row>
      </mat-table>

      <!-- Mobile version -->
      <div *ghExtIfQuery="'lt-md'" fxLayout="column">
        <div class="toggler">
          <span>{{'lbl_show_rejected' | translate}}</span>
          <mat-slide-toggle [checked]="showRejected" (change)="toggleRejected($event)" class="table-toggler"></mat-slide-toggle>
        </div>

        <gh-ext-infinite-list [tracker]="tracker" [itemHeight]="180">
          <mat-card *ghExtInfiniteScrollFor="let order of dataSource" [ngClass]="getRowClass(order)">
            <mat-card-content>
              <div class="card-content-item">
                <div class="card-content-item-title">{{'lbl_office' | translate}}</div>
                <div class="card-content-item-value">{{ order.officeName }}</div>
              </div>
              <div class="card-content-item">
                <div class="card-content-item-title">{{'lbl_purchase_order' | translate}}</div>
                <div class="card-content-item-value">{{ order.purchaseOrder }}</div>
              </div>
              <div class="card-content-item">
                <div class="card-content-item-title">{{'lbl_status' | translate}}</div>
                <div class="card-content-item-value" [ngClass]="getRowClass(order)">{{ order.status }}</div>
              </div>
              <div class="card-content-item">
                <div class="card-content-item-title">{{'lbl_delivery_date' | translate}}</div>
                <div class="card-content-item-value">{{ order.deliveryDate | typeFormat:'ShortDate' }}</div>
              </div>
            </mat-card-content>
            <mat-card-actions>
              <div>
                <button *ngIf="isOrderPending(order)" type="button" class="small cell-button" mat-stroked-button="" (click)="reject(order)">{{'lbl_reject' | translate}}</button>

                <button *ngIf="isOrderPending(order)" type="button" class="small cell-button" color="primary" mat-flat-button="" (click)="accept(order)">{{'lbl_accept' | translate}}</button>
              </div>

              <button *ngIf="order.fileUrl" type="button" class="small cell-button" mat-stroked-button="" (click)="view(order)">{{'lbl_view' | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </gh-ext-infinite-list>
      </div>
      <gh-ext-load-tracker fxFlex="" #tracker="ghExtLoadTracker"></gh-ext-load-tracker>
    </ng-container>
  </gh-ext-page-content>
</gh-ext-page>
